import App from './classes/app'

export default function contentEditable (config) {
  return new App(config)
}
